// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter-module--container--2qm3a","numbers":"Counter-module--numbers--2HLXr"};